// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__seX0c"};